import React from "react";
import { Col, FormFeedback, Input, Label, Row } from "reactstrap";
import * as Yup from "yup";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { FilePond, registerPlugin } from "react-filepond";

import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";

import { fetchWrapper } from "@helpers/fetchwrapper";

import styles from "@areas/shared/components/personal/modals/styles/customModal.module.css";

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const initialValues = (news) => {
  return {
    id: (news && news.Id) || null,
    idType: (news && news.IdType) || 2,
    title: (news && news.Title) || "",
    description: (news && news.Description) || "",
    body: (news && news.Body) || "",
    slug: (news && news.Slug) || "",
    files:
      (news &&
        news.ImageLink &&
        `/v1/api/fileManager/getFile?path=${news.ImageLink}`) ||
      null,
  };
};

const validationSchema = () => {
  return Yup.object({
    title: Yup.string().required("Заголовок обязателен"),
    description: Yup.string().required("Описание обязательно"),
    body: Yup.string().required("Текст обязателен"),
    slug: Yup.string().required("Ссылка обязательна"),
  });
};

const confirm = (values, successFunc) => {
  let data = new FormData();
  data.append("idType", values.idType);
  data.append("title", values.title);
  data.append("description", values.description);
  data.append("body", values.body);
  data.append("slug", values.slug);

  values.files.forEach((info) => {
    data.append("files", info.file, info.file.name);
  });

  if (values.id) {
    data.append("id", values.id);
    fetchWrapper
      .post(`/v1/api/admin/updatepage?id=${values.id}`, data, false)
      .then(successFunc);
  } else {
    fetchWrapper
      .post(`/v1/api/admin/insertPage`, data, false)
      .then(successFunc);
  }
};

function ModalBodyAdd({ validation }) {
  return (
    <Row className="g-2">
      <Input
        type="hidden"
        name="id"
        defaultValue={validation.values.id || null}
      />
      <Input
        type="hidden"
        name="idType"
        defaultValue={validation.values.idType || 2}
      />
      <Col lg={12}>
        <FilePond
          files={validation.values.files || []}
          onupdatefiles={(e) => {
            validation.setFieldValue("files", e);
          }}
          name="files"
          allowMultiple={false}
          className="filepond filepond-input-multiple"
          labelIdle="Перетащите или нажмите, чтобы загрузить"
          onaddfile={() => validation.setFieldTouched("files")}
        />
      </Col>
      <Col lg={12}>
        <div>
          <Label htmlFor="newsTitle-field" className={styles.label}>
            Заголовок
          </Label>
          <Input
            name="title"
            id="newsTitle-field"
            className={`form-control ${styles.input}`}
            placeholder="Введите заголовок новости"
            type="text"
            validate={{
              required: { value: true },
            }}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.title || ""}
            invalid={
              validation.touched.title && validation.errors.title ? true : false
            }
          />
          {validation.touched.title && validation.errors.title ? (
            <FormFeedback type="invalid" className={styles.invalid}>
              {validation.errors.title}
            </FormFeedback>
          ) : null}
        </div>
      </Col>
      <Col lg={12}>
        <div>
          <Label htmlFor="newsDescription-field" className={styles.label}>
            Описание
          </Label>
          <Input
            name="description"
            id="newsDescription-field"
            className={`form-control ${styles.input}`}
            placeholder="Введите описание новости"
            type="text"
            validate={{
              required: { value: true },
            }}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.description || ""}
            invalid={
              validation.touched.description && validation.errors.description
                ? true
                : false
            }
          />
          {validation.touched.description && validation.errors.description ? (
            <FormFeedback type="invalid" className={styles.invalid}>
              {validation.errors.description}
            </FormFeedback>
          ) : null}
        </div>
      </Col>
      <Col lg={12}>
        <div>
          <Label htmlFor="newsBody-field" className={styles.label}>
            Текст
          </Label>
          <CKEditor
            name="body"
            id="newsBody-field"
            editor={ClassicEditor}
            placeholder="Введите текст новости"
            data={validation.values.body || ""}
            onChange={(event, editor) => {
              const data = editor.getData();
              validation.setFieldValue("body", data);
            }}
            onBlur={() => validation.setFieldTouched("body")}
          />
          {validation.touched.body && validation.errors.body ? (
            <FormFeedback type="invalid" className={styles.invalid}>
              {validation.errors.body}
            </FormFeedback>
          ) : null}
        </div>
      </Col>
      <Col lg={12}>
        <div>
          <Label htmlFor="newsSlug-field" className={styles.label}>
            Ссылка
          </Label>
          <Input
            name="slug"
            id="newsSlug-field"
            className={`form-control ${styles.input}`}
            placeholder="Введите ссылку новости"
            type="text"
            validate={{
              required: { value: true },
            }}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.slug || ""}
            invalid={
              validation.touched.slug && validation.errors.slug ? true : false
            }
          />
          {validation.touched.slug && validation.errors.slug ? (
            <FormFeedback type="invalid" className={styles.invalid}>
              {validation.errors.slug}
            </FormFeedback>
          ) : null}
        </div>
      </Col>
    </Row>
  );
}

export { initialValues, validationSchema, confirm, ModalBodyAdd };
